import { Badge, Breadcrumb, Button, Descriptions, Icon, Layout, PageHeader, Select, Spin, Table, Tag, Tooltip } from 'antd';
import axios from 'axios';
import 'moment-timezone';
import React, { Component } from 'react';
import Moment from 'react-moment';
import { connect } from 'react-redux';
import { Constant } from '../../config';
import CioService from '../../config/cio';
import { getPaymentMethodTagColor, getPaymentMethodTagName } from '../../config/payment';
import { fetchMenuAction } from '../../store/actions/leftSideMenu';
import MyModal from '../Modal';
import './Payment.css';
import ModalSlipImage from './modal-slip-image';
import PaymentDetail from './payment-detail.modal';
import SearchForm from "./search-form";

const { Content } = Layout;
const { Option } = Select;
Moment.globalLocal = false;

class Payment extends Component {
  state = {
    dataSource: [],
    headerStatusText: "Payment List",
    loading: false,
    visibleDetailModal: false,
    currentData: {},
    kycAdminReasonList: [],
    currentSlipImage: '',
    visibleSlipImage: false,
    currentStatus: "all",
  }

  columns = [
    {
      title: 'Create Date (UTC)',
      dataIndex: 'created',
      align: "center",
      render: text => {
        return <Moment unix tz="Etc/UTC" format="MMM DD YYYY HH:mm">{text}</Moment>
      }
    },
    {
      title: 'Invoice No',
      dataIndex: 'invoice_no',
      render: (text, record) => {
        let promotionStr = undefined
        const promotionSummaryDetail = record.promotion_summary_detail
        if (record.promotion_id > 0 && promotionSummaryDetail) {
          promotionStr = `Starter Bonus Package ${promotionSummaryDetail.detail || '-'}`
        }

        const status = record.status || ''
        let badge = "red"
        let statusTxt = "Fail"
        if (status === "confirm") {
          badge = "green"
          statusTxt = "Approved"
        } else if (status === "to_approve") {
          badge = "cyan"
          statusTxt = "Waiting for approve"
        } else if (status === "reject") {
          badge = "orange"
          statusTxt = "Rejected"
        }

        return (
          <span>
            <div>
              {text || '-'}
            </div>
            {promotionStr ? <div><Tag color="blue">{promotionStr}</Tag></div> : null}
            <div><Tag color={badge} style={{marginRight: '0px'}}>{statusTxt}</Tag></div>
          </span>
        )
      }
    },
    {
      title: 'User Information',
      dataIndex: 'member_id',
      render: (text, record) => {
        let tagKYCStatus
        if (!record.kyc_logs_detail || !record.kyc_logs_detail.id)
          tagKYCStatus = <Tag color="orange">No KYC</Tag>

        if (record.kyc_logs_detail && record.kyc_logs_detail.status==="resubmit")
          tagKYCStatus = <Tag color="purple">Waiting for new KYC</Tag>

        let tagViberChannelRequest
        if (record.product_detail && record.product_detail.Type === 'viber') {
          tagViberChannelRequest = <Tag color="orange">No requests Viber channel name</Tag>
          if (record.vbcr)
            tagViberChannelRequest = <Tag color="purple">Viber channel name requested</Tag>
        }

        let tagIsIn25THViberLogic
        if (record.is_in_25th_viber_logic)
          tagIsIn25THViberLogic = <Tag color="geekblue">For Next Month</Tag>

        return (
          <span>
            <div style={{marginBottom: '5px'}}>
              <span style={{fontWeight:'bold', marginRight: '8px'}}>{record.full_name || '-'} ({record.email || '-'})</span>
            </div>
            <div>
              <Tag color="blue">MBRID: {text}</Tag>
              {tagKYCStatus}
              {tagViberChannelRequest}
              {tagIsIn25THViberLogic}
            </div>
          </span>
        )
      }
    },
    {
      title: 'Payment Method',
      dataIndex: 'method',
      align: 'center',
      render: (text,record) => {
        const tagName = getPaymentMethodTagName(text)
        const tagColor = getPaymentMethodTagColor(text)

        let productTag = null;
        if (record.product_package_id > 0) {
          if (record.product_detail) {
            const pd = record.product_detail;
            const pdName = pd.Name;
            const pdCountry = pd.CountryAbbr;
            if (pd.Type === 'sms') {
              productTag = (
                <Tag color="#5da8e4">
                  [SMS] {pdCountry} {pdName}
                </Tag>
              );
            } else if (pd.Type === 'viber') {
              productTag = <Tag color="#938ff1">[Viber] {pdName}</Tag>;
            }  else if (pd.Type === 'whatsapp') {
              productTag = <Tag color="#4eba55">[Whatsapp] {pdName}</Tag>;
            }
          } else {
            productTag = <Tag>{record.product_package_id}</Tag>;
          }
        }

        return <div><Tag color={tagColor}>{tagName}</Tag>{productTag}</div>
      }
    },
    {
      title: 'Amount',
      dataIndex: 'amount',
      align: "center",
      render: (text, record) => {
        let styleCurrentBalance = undefined
        let actualBalance = undefined
        const promotionSummaryDetail = record.promotion_summary_detail
        if (record.promotion_id > 0 && promotionSummaryDetail) {
          actualBalance = <Tag color="green">${(promotionSummaryDetail.total_amount || 0).toLocaleString()}</Tag>
          styleCurrentBalance = { marginRight: '5px', textDecoration: 'line-through' }
        }

        return (
          <div>
            <span style={styleCurrentBalance}>${(text || 0).toLocaleString()}</span>
            <span>{actualBalance}</span>
          </div>
        )
      }
    },
    {
      title: 'Action',
      dataIndex: 'id',
      align: "center",
      width: "15%",
      render: (text, record) => {
        const canActive = (record.status || "") === "to_approve"
        return (
          <div>
              <Tooltip title="Approve">
                <Button
                  type={canActive ? "primary" : "default"}
                  icon={canActive ? "check" : "read"}
                  style={{margin: '5px'}}
                  onClick={() => this.detail2(record)}
                />
              </Tooltip>
              {canActive
                ? (
                  <Tooltip title="Reject">
                    <Button
                      type="danger"
                      icon="close"
                      onClick={()=>this.reject(text)}
                    />
                  </Tooltip>
                )
                : null
              }
          </div>
        )
      }
    }
  ]
  currentPage = 1
  currentSearch = ""
  limit = 10
  totalRows = 0
  breadcrumbRoutes = [
    {
      path: "/",
      breadcrumbName: "Home",
    },
    {
      path: "/payment",
      breadcrumbName: "Payment",
    },
    {
      path: "",
      breadcrumbName: "Payment List",
    }
  ]

  breadcrumbItemRender = (route) => {
    return (
      <span>
        <Icon type={route.icon} />
        <span style={{marginLeft: '4px'}}>{route.breadcrumbName}</span>
      </span>
    )
  }

  componentWillMount() {
    this.props.fetchMenuAction("payment", "all")
    this.setState({ loading: true })

    this.getKYCAdminReason()
  }

  async componentDidMount() {
    this.setState({
      dataSource: await this._getListPayment(),
      loading: false
    })
  }


  getKYCAdminReason = async () => {
    const opt = {
      url: Constant.KYC_ADMIN_REASON_API,
      method: "GET",
      headers: {
        'Authorization': "Bearer " + localStorage.getItem(Constant.SessionKey)
      },
    }
    let resp

    try {
      resp = await axios(opt)
    } catch(e) {
      console.log(e)
      return
    }

    this.setState({kycAdminReasonList: (resp && resp.data ? (resp.data.data || []) : [] )})
  }


  approved = (id) => {
    MyModal.confirm("Approve Transaction?", "", async (f) => {
      if (!f)
        return

      this.setState({
        loading: true,
        visibleDetailModal: false,
      })

      let opt = {
        url: Constant.PAYMENT_APPROVE_API.replace("[id]", id),
        method: "PUT",
        headers: {
          'Authorization': "Bearer " + localStorage.getItem(Constant.SessionKey)
        },
      }
      let resp
      let eMsg = `Something went wrong. Please try again.`
      let eMsgDetail = ""
      let eFlag = false


      const {member_id,country_code} = this.state.currentData

      const payload = {
        id : member_id,
        countryCode : country_code
      }

      try {
        resp = await axios(opt)
        if(resp.data){
          const payloadEventTrackTopUp = {
            id : member_id,
            balance : resp.data.balance
          }
          await CioService.pushTopUpEvent(payloadEventTrackTopUp)
        }
        await CioService.updateProfilePayment(payload);
      } catch (err) {
        resp = err.response
      }

      if (!resp.data) {
        eFlag = true
      } else if (resp.data.error) {
        eFlag = true
        let e = resp.data.error
        eMsgDetail = `[${e.code}] ${e.name}`
      }

      if (eFlag) {
        MyModal.error(eMsg, eMsgDetail, () => {
          window.location.reload()
        })
      } else {
        MyModal.info(`Transaction has been approved successfully.`, "", async () => {
          this.setState({
            loading: false,
            dataSource: await this._getListPayment(this.currentPage, this.limit, this.currentSearch)
          })
        })
      }
    }, "Yes", "No")
  }

  reject = (id) => {
    MyModal.confirm("Reject Transaction?", "", async (f) => {
      if (!f)
        return

      this.setState({ loading: true })

      let opt = {
        url: Constant.PAYMENT_REJECT_API.replace("[id]", id),
        method: "PUT",
        headers: {
          'Authorization': "Bearer " + localStorage.getItem(Constant.SessionKey)
        },
      }
      let resp
      let eMsg = `Something went wrong. Please try again.`
      let eMsgDetail = ""
      let eFlag = false

      try {
        resp = await axios(opt)
      } catch (err) {
        resp = err.response
      }

      if (!resp.data) {
        eFlag = true
      } else if (resp.data.error) {
        eFlag = true
        let e = resp.data.error
        eMsgDetail = `[${e.code}] ${e.name}`
      }

      if (eFlag) {
        MyModal.error(eMsg, eMsgDetail, () => {
          window.location.reload()
        })
      } else {
        MyModal.info(`Transaction has been rejected successfully.`, "", async () => {
          this.setState({
            loading: false,
            dataSource: await this._getListPayment(this.currentPage, this.limit, this.currentSearch)
          })
        })
      }
    }, "Yes", "No")
  }

  detail = (d) => {
    let dateToFormat = "MMM DD YYYY HH:mm:ss"
    let badge = "warning"
    let statusTxt = "Fail"
    let approvedLabelTxt = "Approve"
    if (d.status === "confirm") {
      badge = "success"
      statusTxt = "Approved"
    } else if (d.status === "to_approve") {
      badge = "processing"
      statusTxt = "Waiting for approve"
    } else if (d.status === "reject") {
      badge = "error"
      statusTxt = "Rejected"
      approvedLabelTxt = "Reject"
    }

    let domCreated = "-"
    if (d.created > 0) {
      domCreated = <Moment unix tz="Etc/UTC" format={dateToFormat}>{d.created}</Moment>
    }

    let domHookUpdate = "-"
    if (d.hook_update > 0) {
      domHookUpdate = <Moment unix tz="Etc/UTC" format={dateToFormat}>{d.hook_update}</Moment>
    }

    let paymentMethod = "-"
    if (d.method === "2c2p") {
      paymentMethod = "2C2P"
    } else if (d.method === "banktransfer") {
      paymentMethod = "Bank Transfer"
    }

    let promotionTxt = "-"
    let amountWithPromotionTxt = "-"
    if (d.promotion_summary_detail) {
      promotionTxt = d.promotion.replace(/_/g, " ") + " " + d.promotion_summary_detail.detail
      amountWithPromotionTxt = "$" + d.promotion_summary_detail.total_amount
    }

    let adminName = "-"
    if (d.approved_by > 0 && d.admin_detail) {
      adminName = d.admin_detail.firstname ? d.admin_detail.firstname + " " + d.admin_detail.lastname : d.admin_detail.email
    }

    let approvedDate = "-"
    if (d.approved_date > 0) {
      approvedDate = <Moment unix tz="Etc/UTC" format={dateToFormat}>{d.approved_date}</Moment>
    }


    MyModal.detail("Order Details",
      <Descriptions
        bordered={true}
        column={{ xxl: 3, xl: 2, lg: 1, md: 1, sm: 1, xs: 1 }}
      >
        <Descriptions.Item label="Payment Method">{paymentMethod}</Descriptions.Item>
        <Descriptions.Item label="Invoice No.">{d.invoice_no}</Descriptions.Item>
        <Descriptions.Item label="Order No." span={1}>{d.order_no}</Descriptions.Item>

        <Descriptions.Item label="Transaction Date (UTC)">{domCreated}</Descriptions.Item>
        <Descriptions.Item label="Successful Transaction Date (UTC)" span={2}>{domHookUpdate}</Descriptions.Item>

        <Descriptions.Item label="Amount">${d.amount}</Descriptions.Item>
        <Descriptions.Item label="Promotion">{promotionTxt}</Descriptions.Item>
        <Descriptions.Item label="Grand Total" >{amountWithPromotionTxt}</Descriptions.Item>

        <Descriptions.Item label="Status" span={3}>
          <Badge status={badge} text={statusTxt} />
        </Descriptions.Item>

        <Descriptions.Item label="Full Name">{d.full_name}</Descriptions.Item>
        <Descriptions.Item label="Email" span={2}>{d.email}</Descriptions.Item>

        <Descriptions.Item label="Address" span={3}>
          {d.company_name + " " + d.address}<br />
          {d.city + " " + d.state}<br />
          {d.zip_code}
        </Descriptions.Item>

        <Descriptions.Item label={approvedLabelTxt + "By"}>{adminName}</Descriptions.Item>
        <Descriptions.Item label={approvedLabelTxt + "Date (UTC)"} span={2}>{approvedDate}</Descriptions.Item>

      </Descriptions>
    )
  }

  detail2 = (d) => {
    this.setState({
      currentData: d,
      visibleDetailModal: true
    })
  }

  onCloseDetailModal = () => {
    this.setState({ visibleDetailModal: false })
  }

  searchPayment = (fd) => {
    fd.validateFields(async (err, values) => {
      if (err)
        return

      this.setState({ loading: true })

      this.currentPage = 1
      this.currentSearch = values.searchTxt
      this.limit = 10
      this.setState({
        dataSource: await this._getListPayment(1, 10, this.currentSearch),
        loading: false
      })
    })
  }

  resetSearchPayment = async () => {
    this.setState({ loading: true })
    this.currentPage = 1
    this.currentSearch = ""
    this.setState({
      dataSource: await this._getListPayment(),
      loading: false,
    })
  }

  changePage = async (page, limit) => {
    this.setState({ loading: true })
    this.currentPage = page
    this.limit = limit
    this.setState({
      dataSource: await this._getListPayment(
        page,
        limit,
        this.currentSearch,
      ),
      loading: false
    })
  }

  handleStatusChange = async (value) => {
    await this.setState({ currentStatus: value, loading: true });
    this.currentPage = 1;
    const dataSource = await this._getListPayment(1, this.limit, this.currentSearch);
    this.setState({
        dataSource,
        loading: false,
    });
  }

  _getListPayment = async (page = 1, limit = 10, search = "") => {
    let url = Constant.PAYMENT_API + "?page=" + page + "&limit=" + limit + "&search=" + search
    let status = this.state.currentStatus;
    if (status === "all") {
        status = ""
    }

    url += "&status=" + status

    let opt = {
      url,
      method: "GET",
      headers: {
        'Authorization': "Bearer " + localStorage.getItem(Constant.SessionKey)
      },
    }
    let resp

    try {
      resp = await axios(opt)
    } catch (err) {
      resp = err.response
    }

    if (!resp.data) {
      console.log(resp.data)
      return []
    }

    if (resp.data.error) {
      console.log(resp.data.error)
      return []
    }

    this.totalRows = resp.data.total_rows || 0

    return resp.data.data
  }

  onCloseSlipImage = () => {
    this.setState({
      currentSlipImage: '',
      visibleSlipImage: false,
    });
  };

  viewImageSlip = (imgUrl) => {
    if (!imgUrl) return;

    this.setState({
      currentSlipImage: imgUrl,
      visibleSlipImage: true,
    });
  };

  render() {
    const propsTable = {
      columns: this.columns,
      dataSource: this.state.dataSource,
      rowKey: record => record.id,
      pagination: {
        pageSize: this.limit,
        total: this.totalRows,
        current: this.currentPage,
        onChange: this.changePage,
        size: "small"
      },
      bordered: true,
      scroll: {x: true}
    }

    return (
      <Layout>
        <Breadcrumb className="breadcrumb">
          {this.breadcrumbRoutes.map((route, idx) => (
            <Breadcrumb.Item key={idx}>
              {route.path ? <a href={route.path}>{route.breadcrumbName}</a> : route.breadcrumbName}
            </Breadcrumb.Item>
          ))}
        </Breadcrumb>
        <PageHeader
          style={{
            backgroundColor: "#f0f2f5",
          }}
          title={<h2 style={{ fontWeight: "bold" }}>{this.state.headerStatusText}</h2>} />
        <div className="my-layout">
          <Spin spinning={this.state.loading} tip="Loading...">
            <Content className="main-container">
              <div className='main-container-inner'>
              <div className="utility-bar" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                  <div>
                      <span style={{ marginRight: '8px' }}>Status:</span>
                      <Select
                        value={this.state.currentStatus}
                        style={{ width: 200 }}
                        onChange={this.handleStatusChange}
                      >
                        <Option value="all">All Status</Option>
                        <Option value="to_approve">Waiting for Approve</Option>
                        <Option value="confirm">Approved</Option>
                        <Option value="reject">Rejected</Option>
                      </Select>
                  </div>
                  <div>
                      <SearchForm
                        fn={this.searchPayment}
                        fnReset={this.resetSearchPayment}
                        placeholder="Invoice no, Email"
                      />
                  </div>

              </div>
              </div>
              <Table {...propsTable} />
            </Content>
          </Spin>
          <PaymentDetail
            visibleDetailModal={this.state.visibleDetailModal}
            onCloseDetailModal={this.onCloseDetailModal}
            data={this.state.currentData}
            approved={this.approved}
            kycAdminReasonList={this.state.kycAdminReasonList}
            viewImageSlip={this.viewImageSlip}
          />
          <ModalSlipImage
            visible={this.state.visibleSlipImage}
            onClose={this.onCloseSlipImage}
            imgPath={this.state.currentSlipImage}
          />
        </div>
      </Layout>
    )
  }
}

const mapDispatchToProps = dispatch => {
  return {
    fetchMenuAction: (menuParentKey, menuKey) => dispatch(fetchMenuAction(menuParentKey, menuKey))
  }
}

export default connect(null, mapDispatchToProps)(Payment)


// WEBPACK FOOTER //
// ./src/containers/Payment/index.js